module.exports = __webpack_public_path__ + "src/assets/img/hood_color.936c7b12.svg";